import {updateTotal} from './catalog/counter';
document.querySelectorAll('.counter').forEach((counter) => {
    const digit = counter.querySelector('.counter__digit');
    const plusBtn = counter.querySelector('.counter__control.plus');

    let count = parseInt(digit.value) || 1;
    const min = count;
    const max = plusBtn?.dataset.max ? parseInt(plusBtn.dataset.max) : Infinity;

    counter.addEventListener('click', (e) => {
        const btn = e.target.closest('.counter__control');
        if (!btn) return;

        if (btn.textContent.trim() === '-' && count > min) count--;
        if (btn.textContent.trim() === '+' && count < max) count++;

        digit.value = count;
        updateTotal(Number(counter.dataset.price), count);
    });
});
